import { render, staticRenderFns } from "./ParcelDropImage.vue?vue&type=template&id=14295c14&"
import script from "./ParcelDropImage.vue?vue&type=script&lang=js&"
export * from "./ParcelDropImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib'
import { VProgressCircular } from 'vuetify/lib'
installComponents(component, {
  VImg,
  VProgressCircular,
})
